import { Badge } from '@cannect/new-components/atoms'
import { cn } from '@cannect/lib/utils'
import type { SubscriptionDisplayState } from '@cannect/services/resources/recurrency/helpers'

// Cores com contraste AA (texto escuro sobre fundo claro).
const VARIANT_CLASSES: Record<SubscriptionDisplayState['chipVariant'], string> = {
  success: 'bg-success-100 text-primary-1000 hover:bg-success-100',
  warning: 'bg-warning-200 text-neutral-800 hover:bg-warning-200',
  danger: 'bg-red-100 text-red-800 hover:bg-red-100',
  neutral: 'bg-neutral-200 text-neutral-800 hover:bg-neutral-200'
}

export const StatusChip = ({ state, className }: { state: SubscriptionDisplayState; className?: string }) => (
  <Badge
    size="xs"
    className={cn('whitespace-nowrap !text-xs font-semibold', VARIANT_CLASSES[state.chipVariant], className)}>
    {state.chipLabel}
  </Badge>
)
